import { Component, EventEmitter, HostBinding, HostListener, Input, Output, ViewChild } from '@angular/core';
import { ContextMenuComponent } from '@app/shared/components/context-menu/context-menu.component';
import { Batch } from '@app/shared/models/batch.model';
import { TranslateService } from '@ngx-translate/core';
import { MenuItem } from "primeng/api";

@Component({
    selector: 'app-batch',
    templateUrl: './batch.component.html',
    styleUrls: ['./batch.component.scss']
})
export class BatchComponent {
    @ViewChild(ContextMenuComponent, {static: true}) contextMenu: ContextMenuComponent;

    @Input() batch: Batch;
    @Input() @HostBinding("class.settings") hasSettings = false;
    @Input() @HostBinding('class.selected') selected = false;

    @Output() select = new EventEmitter<any>();
    @Output() settings = new EventEmitter<any>();
    @Output() edit = new EventEmitter<any>();
    @Output() delete = new EventEmitter<any>();
    @Output() duplicate = new EventEmitter<any>();

    contextMenuItems: MenuItem[] = [];

    constructor(private translate: TranslateService) {
        this.contextMenuItems = [
            {
                label: this.translate.instant('generic.buttons.duplicate'),
                icon: "fa fa-clone",
                command: () => this.onDuplicate(),
            },
            {
                label: this.translate.instant('generic.buttons.edit'),
                icon: "fa fa-pencil",
                command: () => this.onEdit(),
            },
            {
                label: this.translate.instant('generic.buttons.delete'),
                icon: "fa fa-trash",
                command: () => this.onDelete(),
            },
        ];
    }


    @HostListener('click', ['$event.target'])
    onBatchClick() {
        this.select.emit(this.batch);
    }

    onSettingsClick(event) {
        event.stopPropagation();
        event.preventDefault();
        this.settings.emit(this.batch);
        this.contextMenu.show(event);
    }

    onDelete() {
        this.delete.emit(this.batch);
    }

    onEdit() {
        this.edit.emit(this.batch);
    }

    onDuplicate() {
        this.duplicate.emit(this.batch);
    }

    closeContextMenu() {
        this.contextMenu.close();
    }
}
